import { StatusValue } from '../../shared/types';

interface MessageMap<T> {
    [key: string]: T;
}

export interface IVerificationTrustMap {
    name: string;
    description: string;
    status: StatusValue;
}

export const trustReasonMap: MessageMap<IVerificationTrustMap> = {
    docFrontBackMatch: {
        name: 'ID Front & Back Match',
        description: 'Indicates a good match of data front & back.',
        status: StatusValue.Passed
    },
    docFrontBackNoMatch: {
        name: 'ID Front & Back do not Match',
        description: 'Data associated with front/back of ID did not match each other.',
        status: StatusValue.Failed
    },
    docIrregularOrTampered: {
        name: 'ID is Irregular or Tampered',
        description: 'ID that was captured had irregular markings and/or doc appears to have been tampered with.',
        status: StatusValue.Failed
    },
    faceMatch: {
        name: 'ID & Selfie Face Match',
        description: 'Selfie matches the photo on the ID.',
        status: StatusValue.Passed
    },
    faceNoMatch: {
        name: 'Selfie does not Match ID Photo',
        description: ' Selfie does not match the photo on ID.',
        status: StatusValue.Failed
    },
    faceImageIrregularOrTampered: {
        name: 'Selfie is Irregular or Tampered',
        description: 'Selfie has irregular qualities and/or image appears to have been tampered with.',
        status: StatusValue.Failed
    },
    faceMatchLowConfidence: {
        name: 'ID & Selfie Face Match Low Confidence',
        description:
            ' Indicates on a scale of 0-100 (higher the better) that this selfie photo compared to ID had a score between 0-59.',
        status: StatusValue.Failed
    },
    faceMatchMediumConfidence: {
        name: 'ID & Selfie Face Match Medium Confidence',
        description:
            'Indicates on a scale of 0-100 (higher the better) that this selfie photo compared to ID had a score between 60-79.',
        status: StatusValue.Undetermined
    },
    faceMatchHighConfidence: {
        name: 'ID & Selfie Face Match High Confidence',
        description:
            'Indicates on a scale of 0-100 (higher the better) that this selfie photo compared to ID had a score between 80-100.',
        status: StatusValue.Passed
    },
    docExpired: {
        name: 'ID Document Expired',
        description: 'Expiration date on ID is in the past.',
        status: StatusValue.Undetermined
    },
    docTypeNotSupported: {
        name: 'ID Doc Not Supported',
        description: 'Doc user captured was not supported.',
        status: StatusValue.Undetermined
    },
    docPhotoNotVisible: {
        name: 'ID Doc Photo Not Visible',
        description: 'No photo visible on the ID.',
        status: StatusValue.Undetermined
    },
    livenessLive: {
        name: 'Selfie Liveness Test Live',
        description: 'Selfie passed the liveness detection test.',
        status: StatusValue.Passed
    },
    livenessNotLive: {
        name: 'Selfie Liveness Test Not Live',
        description: 'Selfie did not pass liveness detection test.',
        status: StatusValue.Undetermined
    },
    sharedSsn: {
        name: 'Shared SSN',
        description: 'SSN is also used by other identifies found in Equifiax credit files.',
        status: StatusValue.Failed
    },
    verifiedSsn: {
        name: 'SSN Verified',
        description: 'SSN can be verified by data furnishers.',
        status: StatusValue.Failed
    },
    invalidSsn: {
        name: 'Invalid SSN',
        description: 'SSN contains obvious erroneous or dummy numbers.',
        status: StatusValue.Failed
    },
    sharedAddress: {
        name: 'Shared Address',
        description: 'If address is used by many other identities recently found in Equifax.',
        status: StatusValue.Failed
    },
    identityConfirmation1: {
        name: 'Identify Confirmation',
        description: 'If name matches to property owner.',
        status: StatusValue.Failed
    },
    identityConfirmation2: {
        name: 'Identify Confirmation',
        description: 'If name matches to household info to address.',
        status: StatusValue.Failed
    },
    inquiry: {
        name: 'Inquiry',
        description: 'SSN is found in SSA death master file.',
        status: StatusValue.Failed
    },
    deathMasterHit: {
        name: 'Death Master Hit',
        description: 'If risky inquiry patterns related to hyper credit monitoring are detected.',
        status: StatusValue.Failed
    }
};
